import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { TechSupportCommunicationStore } from '../stores/techSupportCommunicationStore';

export const useTechSupportCommunicationStore = () => useContext<{
  techSupportCommunicationStore: TechSupportCommunicationStore
}>(StoreContext);
